import React from 'react';
import { PageAbsolutePath } from '../../consts/Common';
import ReloadHandler from '../common/ReloadHandler';
import { useJourney } from './Layout';
import { useTranslation } from 'react-i18next';

const FailedRegistration = (): JSX.Element => {
  const { journey } = useJourney();
  const { registrationFailMsg } = journey;
  const { t } = useTranslation();

  return (
    <div>
      <h3>{t('confirmation.purchase-not-completed-message')}</h3>
      <p className='p2 m1-bottom'>{registrationFailMsg}</p>
      <p className='p2'>{t('confirmation.contact-us-message')}</p>
      <ReloadHandler reloadPath={PageAbsolutePath.Landing} />
    </div>
  );
};

export default FailedRegistration;
